import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useLocation, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag, UpdatePassword } from "../../slices/thunks";

import { createSelector } from "reselect";
//import images
import BNRathiLogo from "../../assets/images/BNRathiLogo.png";
import PasswordResetSuccessModal from "../../Components/Modals/PasswordResetSuccessModal";
import LoginPageLogo from "../../Components/Common/LoginPageLogo";

const SetPassword = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location",location)
  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    // loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  // Inside your component
  const { user, error, errorMsg } = useSelector(loginpageData);
  const [loading, setLoading] = useState(false);
  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [showModal, setShowModal] = useState({
    show: false,
    data: {},
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: "",
      password: "",
      password_confirmation: "",
    },
    validationSchema: Yup.object({
      // username: Yup.string().required("Please Enter Your Username!"),
      password: Yup.string()
    .required("Please enter your password!")
    .min(8, "Password must be at least 8 characters!")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter!")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter!")
    .matches(/[0-9]/, "Password must contain at least one number!")
    .matches(/[\W_]/, "Password must contain at least one special character!"), // \W matches any non-word character

  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords do not match!")
    .required("Please confirm your password!"),
    }),
    onSubmit: (values) => {
      // console.log("values", values);
      setLoading(true);
      dispatch(UpdatePassword({user:values, token:location?.state?.token})).then((res)=>{
        // console.log("res",res);
        if(res?.code===200){
          setShowModal({
            show: true,
            data: values,
          });
        }
        setLoading(false);
      }).catch((err)=>{
        // console.log("err",err)
        setShowModal({
          show: false,
          data: values,
        });
        setLoading(false);
      })
      
      // dispatch(loginUser(value, props.router.navigate));
    },
  });

  const onCloseClick = () => {
    // navigate('/login',{replace:true})
    setShowModal({
      show: false,
      data: {},
    });
  };

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  document.title = "Bonanza Partner | Login";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={12} lg={10} xl={10} className="">
                <Card className="mt-4 mb-0">
                  <CardBody className="p-0">
                    <Row className="m-0 p-0">
                      
                    <LoginPageLogo />
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} className="p-0">
                        <div className="p-4">
                          <div className="text-center mt-2">
                            <h3 className="text-dark mb-1">Set New Password</h3>
                            {/* <p className="text-muted fs-p-sm">
                              Sign in to continue
                            </p> */}
                          </div>

                          <div className="p-2 w-100 mt-4">
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                              }}
                              action="#"
                            >
                              <div className="mb-3">
                                <Label
                                  htmlFor="userpassword"
                                  className="form-label"
                                >
                                  New Password{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="position-relative auth-pass-inputgroup mb-3">
                                  <Input
                                    name="password"
                                    value={validation.values.password || ""}
                                    type={passwordShow ? "text" : "password"}
                                    className="form-control pe-5"
                                    placeholder="Enter new password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.password &&
                                      validation.errors.password
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.password &&
                                  validation.errors.password ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password}
                                    </FormFeedback>
                                  ) : null}
                                  <button
                                    className=" btn btn-link eyeIcon position-absolute end-0 top-0 text-decoration-none text-muted"
                                    onClick={() =>
                                      setPasswordShow(!passwordShow)
                                    }
                                    type="button"
                                    id="password-addon"
                                  >
                                    <i
                                      className={
                                        validation.touched.password &&
                                        validation.errors.password
                                          ? "ri-eye-fill align-middle me-4"
                                          : "ri-eye-fill align-middle"
                                      }
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              <div className="mb-2">
                                <Label
                                  htmlFor="confirmPassword"
                                  className="form-label"
                                >
                                  Confirm Password{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="position-relative auth-pass-inputgroup mb-3">
                                  <Input
                                    name="password_confirmation"
                                    value={
                                      validation.values.password_confirmation || ""
                                    }
                                    type={
                                      confirmPasswordShow ? "text" : "password"
                                    }
                                    className="form-control pe-5"
                                    placeholder="Enter confirm password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.password_confirmation &&
                                      validation.errors.password_confirmation
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.password_confirmation &&
                                  validation.errors.password_confirmation ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password_confirmation}
                                    </FormFeedback>
                                  ) : null}
                                  <button
                                    className=" btn btn-link eyeIcon position-absolute end-0 top-0 text-decoration-none text-muted"
                                    onClick={() =>
                                      setConfirmPasswordShow(
                                        !confirmPasswordShow
                                      )
                                    }
                                    type="button"
                                    id="password-addon2"
                                  >
                                    <i
                                      className={
                                        validation.touched.password_confirmation &&
                                        validation.errors.password_confirmation
                                          ? "ri-eye-fill align-middle me-4"
                                          : "ri-eye-fill align-middle"
                                      }
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* <div className="form-check">
                      <Input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="auth-remember-check"
                      />
                      <Label
                        className="form-check-label"
                        htmlFor="auth-remember-check"
                      >
                        Remember me
                      </Label>
                    </div> */}

                              <div className="mt-4">
                                <Button
                                  color="success"
                                  disabled={
                                    error ? null : loading ? true : false
                                  }
                                  className="btn btn-success w-100"
                                  type="submit"
                                >
                                  {loading ? (
                                    <Spinner size="sm" className="me-2">
                                      {" "}
                                      Loading...{" "}
                                    </Spinner>
                                  ) : null}
                                  Set Password
                                </Button>
                              </div>
                            </Form>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <div className="mt-4 text-center">
                  <p className="mb-2 text-white">
                    Don't have an account ?{" "}
                    <Link
                      to="https://ekyc.bnrsecurities.com/invite?rc=KE87F3"
                      target="_blank"
                      className="fw-semibold text-white text-decoration-underline"
                    >
                      {" "}
                      Signup{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>

      {showModal?.show && 
        <PasswordResetSuccessModal
        showModal={showModal}
        onCloseClick={onCloseClick}
        />
      }
    </React.Fragment>
  );
};

export default withRouter(SetPassword);
